/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordVerifyAttestationData
 */
export interface PasswordVerifyAttestationData {
    /**
     * 
     * @type {string}
     * @memberof PasswordVerifyAttestationData
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordVerifyAttestationData interface.
 */
export function instanceOfPasswordVerifyAttestationData(value: object): value is PasswordVerifyAttestationData {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function PasswordVerifyAttestationDataFromJSON(json: any): PasswordVerifyAttestationData {
    return PasswordVerifyAttestationDataFromJSONTyped(json, false);
}

export function PasswordVerifyAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerifyAttestationData {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function PasswordVerifyAttestationDataToJSON(json: any): PasswordVerifyAttestationData {
    return PasswordVerifyAttestationDataToJSONTyped(json, false);
}

export function PasswordVerifyAttestationDataToJSONTyped(value?: PasswordVerifyAttestationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
    };
}

